import { userLevelOptionList } from '@/constants/userManagement';
import { userGetterType } from '@/vuex-store/user/getters';
const vuexGetters = {
    getterPageType: ({ type }) => type,
    getterUserDetail: ({ userDetail }) => userDetail,
    getterUserId: ({ userDetail }) => userDetail?.userId,
    getterUserLevelList: (state, getters, rootState, rootGetters) => {
        /**
         * 총판마스터/총판사용자/총판관리자 : 총판마스터(42), 허브 마스터(32) 변경 불가
         * 허브마스터/허브사용자/허브관리자 : 청판마스터(42),청판관리자(41),총판사용자(40),허브마스터(32) 변경불가
         */
        const unselectableLevelByDistUser = [
            '42',
            '32',
        ];
        const unselectableLevelByHubUser = [
            '42',
            '41',
            '40',
            '32',
        ];
        const isDistUser = rootGetters[userGetterType.isDistUser];
        if (isDistUser) {
            return userLevelOptionList
                .filter((item) => !unselectableLevelByDistUser.includes(item.value)
                || item.value === 'ALL');
        }
        return userLevelOptionList
            .filter((item) => !unselectableLevelByHubUser.includes(item.value)
            || item.value === 'ALL');
    },
    getterHubList: ({ hubList }) => hubList || [],
};
export default vuexGetters;
